import { render, staticRenderFns } from "./formBuilder.vue?vue&type=template&id=09035331&scoped=true"
import script from "./formBuilder.vue?vue&type=script&lang=js"
export * from "./formBuilder.vue?vue&type=script&lang=js"
import style0 from "./formBuilder.vue?vue&type=style&index=0&id=09035331&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09035331",
  null
  
)

export default component.exports